import { createSlice } from '@reduxjs/toolkit';
import { deserialize } from 'deserialize-json-api';
// utils
import axios from '../../../utils/axios';
import { dispatch } from '../../store';

const initialState = {
  isLoading: false,
  dashboardOrderMetrics: [],
  defaultPeriod: 'This Week',
};

const slice = createSlice({
  name: 'Retailer Dashboard Metrics',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // STOP LOADING
    stopLoading(state) {
      state.isLoading = false;
    },

    // STOP LOADING
    setDefaultPeriod(state, action) {
      state.defaultPeriod = action.payload;
    },

    // Success Deliveries
    getDashboardOrderMetricsSuccess(state, action) {
      state.isLoading = false;
      state.dashboardOrderMetrics = action.payload.data;
    },
  },
});

// reducers
export default slice.reducer;

export function getDashboardOrderMetrics(period) {
  return async () => {
    try {
      let pathName = `/retailer_app/api/v1/retailer/metrics/${period ? period : 'This Week'}`;
      const response = await axios.get(pathName.toString());
      const data = deserialize(response.data, { transformKeys: 'camelCase' });

      dispatch(slice.actions.getDashboardOrderMetricsSuccess(data));
    } catch (error) {
      console.error('Error fetching retailer metrics:', error);
      throw error;
    }
  };
}

export function setDefaultPeriod(data) {
  return async () => {
    try {
      dispatch(slice.actions.setDefaultPeriod(data));
    } catch (error) {
      throw error;
    }
  };
}
